/* Live character count under each personalization name field. The markup ships a
   static 0/N; this keeps it honest as the customer types. Kept out of the section
   file, which is near Shopify's 256 KB limit. */
(function(){
  if (window.__cjiNameCounts) return;
  window.__cjiNameCounts = true;
  function bind(){
    document.querySelectorAll('.cji-name-count').forEach(function(c){
      var f = document.getElementById(c.getAttribute('data-for'));
      if (!f || f.__cjiBound) return;
      f.__cjiBound = true;
      var max = f.getAttribute('maxlength');
      function upd(){
        c.textContent = f.value.length + '/' + max;
        c.classList.toggle('cji-name-full', f.value.length >= parseInt(max, 10));
      }
      f.addEventListener('input', upd);
      upd();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  setTimeout(bind, 600);
})();
